module.exports = __webpack_public_path__ + "img/sb_br_zj.64a8991f.png";